// extracted by mini-css-extract-plugin
export default {"errorPlaceholder":"styles_errorPlaceholder__5XId7"};